import { Dropdown, DropdownItem, InputField } from 'plume-ui';
import { AdjustableComponent } from 'plume-ui/dist/hooks/useClasses';
import { memo, useEffect, useState } from 'react';
import {
  makePayload,
  mapMinutesToDaysHoursMinutes,
  verifyNumberInput,
} from '../helpers';
import {
  DurationType,
  FilterSubcriteriaDefaultProps,
  TimeType,
} from '../types';
import { useTranslation } from 'react-i18next';

type DurationStyles = {
  root: string;
};

const Duration: AdjustableComponent<
  FilterSubcriteriaDefaultProps,
  DurationStyles
> = ({ allowedOperators, setValue, initialData }) => {
  const { t } = useTranslation();

  const [data, setData] = useState<DurationType>({
    value: 0,
    operator: initialData?.operator
      ? allowedOperators.find((op) => op.key === initialData.operator) ??
        allowedOperators[0]
      : allowedOperators[0],
    criteriaType: 'duration',
  });
  const [timeData, setTimeData] = useState<TimeType>(
    mapMinutesToDaysHoursMinutes((initialData?.selectedValue as number) || 0),
  );

  useEffect(() => {
    setValue(makePayload(data));
  }, [data]);

  useEffect(() => {
    setData({
      ...data,
      value:
        timeData.minutes + 60 * (timeData.hours + 24 * (timeData.days || 0)),
    });
  }, [timeData]);

  return (
    <>
      <Dropdown closeOnItemClick label={data.operator.display} openInPortal>
        {allowedOperators.map((option) => (
          <DropdownItem
            key={option.key}
            onClick={() =>
              setData({
                ...data,
                operator: option,
              })
            }
          >
            {option.display}
          </DropdownItem>
        ))}
      </Dropdown>
      <div className="Duration" data-testid="duration-component">
        <div className="Duration__input">
          <InputField
            type="number"
            id="durationDays"
            value={timeData.days}
            onInput={(event: any) => {
              const inputValue = verifyNumberInput(event.target.value, 364, 0);
              event.target.value = inputValue;
              setTimeData({ ...timeData, days: inputValue });
            }}
            min={0}
            maxLength={3}
          />
          <label htmlFor="durationDays">{t('genericLabels.days')}</label>
        </div>
        <div className="Duration__input">
          <InputField
            type="number"
            id="durationHours"
            value={timeData.hours}
            onInput={(event: any) => {
              const inputValue = verifyNumberInput(event.target.value, 23, 0);
              event.target.value = inputValue;
              setTimeData({ ...timeData, hours: inputValue });
            }}
            max={23}
            min={0}
            maxLength={2}
          />
          <label htmlFor="durationHours">{t('genericLabels.hours')}</label>
        </div>
        <div className="Duration__input">
          <InputField
            type="number"
            id="durationMinutes"
            value={timeData.minutes}
            onInput={(event: any) => {
              const inputValue = verifyNumberInput(event.target.value, 59, 0);
              event.target.value = inputValue;
              setTimeData({ ...timeData, minutes: inputValue });
            }}
            max={59}
            min={0}
            maxLength={2}
          />
          <label htmlFor="durationMinutes">{t('genericLabels.minutes')}</label>
        </div>
      </div>
    </>
  );
};

export default memo(Duration);
